import React from 'react';
import { Container, Row, Col, Image, ListGroup } from 'react-bootstrap';
import Blog4 from '../Components/img/Blog4.jpg'; // Using the image from the blog

const Mindfulness = () => {
  return (
    <Container className="py-5">
      <Row className="align-items-center">
        <Col md={6}>
        <h2 className="text-dark">Mindfulness and Mental Clarity</h2>
          <p className="text-muted">
            Mindfulness is the practice of being fully present in the moment. It helps in reducing stress, 
            enhancing mental clarity, and improving emotional resilience. By focusing on the present, we can 
            develop better awareness and control over our thoughts and emotions.
          </p>
          <p className="text-muted">
            Incorporating mindfulness into daily life fosters nmcalmness, promotes better decision-making, and 
            strengthens our ability to handle challenges with a clear mind.
          </p>

          <Image src={Blog4} alt="Mindfulness and Mental Clarity" fluid className="rounded shadow" />
        </Col>
        <Col md={6}>
       
          <h5 className="text-dark mt-4">Benefits of Mindfulness:</h5>
          <ListGroup variant="flush" className="mt-3">
            <ListGroup.Item>✅ <strong>Reduces Stress & Anxiety:</strong> Mindfulness helps calm the mind and manage stress levels.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Enhances Focus & Concentration:</strong> Increases productivity by improving attention span.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Boosts Emotional Well-being:</strong> Helps cultivate a positive and balanced mindset.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Improves Sleep Quality:</strong> Encourages relaxation and deeper rest.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Encourages Self-Awareness:</strong> Helps in recognizing thoughts and emotions more effectively.</ListGroup.Item>
          </ListGroup>

          <p className="text-muted mt-3">
            Learn how to integrate mindfulness techniques into your routine, from **breathing exercises** to **meditation practices**, 
            and experience the profound impact of living in the present moment.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Mindfulness;
